import {inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {LoggerService} from "./logger.service";

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private logger = inject(LoggerService);
  // private socket: Socket;

  constructor() {
    this.logger.debug('SocketService initialized')
    // this.socket = io('ws://localhost:3000', { auth: {'ClientType': 'angular', 'ClientApiKey': 'ak_8b8f6f981c154fd8b0ec69c63c6f913a97053ce7beb4115efa3938273ee738a8970cd1a22c9877e12b2b804732c6df8e5cce1f564c3f414dedd58d0e591efc65'}});
  }

  emit(event: string, data: any) {
    // this.socket.emit(event, data);
  }

  on(event: string): Observable<any> {
    return new Observable((observer) => {
      // this.socket.on(event, (data) => { observer.next(data) });
      // // Handle cleanup
      // return () => {
      //   this.socket.off(event);
      // };
    });
  }
}
